<template>
  <div class="r-content">
    <div class="border-bottom" v-if="all.videoList && all.videoList.length > 0">
      <h4 class="title line2">{{ all.sys_course_title }}</h4>
      <div class="sum">共{{ all.sys_course_total }}个课时</div>
      <div class="list">
        <router-link
          tag="div"
          replace
          class="item"
          v-for="v in all.videoList"
          :key="v.video_id"
          :to="(bought || v.isallow) ? '/play/' + v.course_id + '/' + v.video_id + '/related' : ''"
          @click.native="tips(v)"
        >
          <div class="img-wrap">
            <img v-lazy="v.thumb" alt />
          </div>
          <div class="name line2" :class="{ active: v.video_id == videoId }">{{ v.title }}</div>
        </router-link>
      </div>
    </div>
    <div>
      <div class="recommend-title">课程列表</div>
      <div class="recommend-list">
        <!-- <related-course-list :data="all.topCourseList" ></related-course-list> -->
        <card-course v-for="item in all.topCourseList" :key="item.id" :data="item"></card-course>
      </div>
    </div>
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
// import RelatedCourseList from './related-course-list'
import CardCourse from '../card/card-course'
import { relatedCourse } from '@/api/play'
import Loading from '../base/loading/loading.vue'
import { RES_OK } from '@/api/config'
export default {
  components: {
    // RelatedCourseList,
    CardCourse,
    Loading
  },
  props: {
    videoId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    bought: {
      type: Boolean
    }
  },
  data() {
    return {
      all: {
      },
      showLoading: false
    }
  },
  created() {
    this.showLoading = true
    relatedCourse(this.courseId).then(res => {
      let data = res.data
      if (data && data.code === RES_OK && data.data) {
        this.all = data.data
      } else if (data && data.msg) {
        console.log(data.msg)
      }
      this.showLoading = false
    })
  },
  methods: {
    tips(v) {
      if (!(this.bought || v.isallow)) {
        // 没买 或者 没有试看
        this.$toast('“立即购买” 即可解锁课程')
      }
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .r-content
    padding-bottom size(130)
  .line2
    overflow hidden
    text-overflow ellipsis
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    word-wrap break-word
    word-break break-all
  .title
    font-size size(34)
    font-weight 800
    padding 0 size(30)
    margin-top size(30)
    line-height 1.4
  .sum
    font-size size(24)
    color #999
    padding 0 size(30)
    margin-top size(10)
  .list
    width 100%
    overflow scroll
    font-size 0
    white-space nowrap
    margin-top size(30)
    padding-bottom size(20)
    .item
      display inline-block
      vertical-align top
      margin-left size(30)
      width size(300)
      &:last-child
        margin-right size(30)
      .img-wrap
        width 100%
        height size(168)
        //background #dddddd
        border 1px solid #eee
        border-radius 6px
        background-size cover
        overflow hidden
        position relative
        img
          position absolute
          width 100%
          top 50%
          left 0
          transform translateY(-50%)
      .name
        font-size size(28)
        line-height 1.4
        width size(300)
        white-space normal
        margin size(12) 0
        &.active
          color $color-theme
  .recommend-title
    font-size size(34)
    font-weight 800
    margin size(40) 0 0
    padding 0 size(30)
  .recommend-list
    padding-left size(30)
    padding-right size(30)
</style>



// WEBPACK FOOTER //
// src/components/play/play-related-course.vue